// Copyright (c) 2022 by Move Closer

import { ComponentObjectPropsOptions } from '../../vue-api'

import { getAbstractInputControlProps } from '../../abstract/components/InputControl/InputControl.hooks'
import { PreEditableProps } from './PreEditable.contracts'

/**
 * @author Piotr Niewczas <piotr.niewczas@movecloser.pl>
 */
export const customPreEditableProps: ComponentObjectPropsOptions<PreEditableProps> = {
  ...getAbstractInputControlProps<string>(),

  /**
   * Value for the `[cols]` attribute of the `<textarea>` element.
   * @default 30
   */
  width: {
    type: Number,
    required: false
  },

  /**
   * Value for the `[height]` attribute of the `<textarea>` element.
   * @default 5
   */
  height: {
    type: Number,
    required: false
  }

}
